import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { videoSection } from "../apiPath/api";

export const createVideoSection = createAsyncThunk(
  "videoSection/createVideoSection",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await videoSection.createVideo(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllVideos = createAsyncThunk(
  "videoSection/getAllVideos",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await videoSection.getAllVideos(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deleteVideos = createAsyncThunk(
  "videoSection/deleteVideos",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await videoSection.deleteVideos(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeleteVideos = createAsyncThunk(
  "videoSection/undoDeleteVideos",
  async (id, { rejectWithValue }) => {
    try {
      const response = await videoSection.undoDeleteVideos(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updateVideos = createAsyncThunk(
  "videoSection/updateVideos",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await videoSection.updateVideos(id, data);
      return response.data;
    } catch (error) {
      console.error("Update error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update team member"
      );
    }
  }
);

const videoSectionSlice = createSlice({
  name: "videoSection",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    videos: [],
  },

  reducers: {
    resetVideoSectionState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.videos = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createVideoSection.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createVideoSection.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createVideoSection.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllVideos.fulfilled, (state, action) => {
        state.loading = false;
        state.videos = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVideos.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeleteVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeleteVideos.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeleteVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateVideos.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateVideos.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updateVideos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetVideoSectionState } = videoSectionSlice.actions;
export default videoSectionSlice.reducer;
